<!doctype html>
<html lang="en">
  <body id="pdf-data" #pdfContent>
    <div class="pdf-content">
      <div data-pdfmake-type="columns">
        <div data-pdfmake='{"width":"10%"}'>
          <img
            [src]="printData?.logo"
            alt="orgLogo"
            style="width: 80pt; height: 40pt" />
        </div>

        <div data-pdfmake='{"width":"*", "margin": [10, 0]}'>
          <div class="desc" style="text-align: right">
            {{ printData?.orgDetail?.address }}
          </div>
          <div class="address" style="text-align: right">
            {{ printData?.orgDetail?.city }}, {{ printData?.orgDetail?.state }},
            {{ printData?.orgDetail?.country }},
            {{ printData?.orgDetail?.zipCode }}
          </div>
        </div>
      </div>

      <hr data-pdfmake='{"color": "#eaecf0", "thickness": 1, "width": 552}' />

      <div data-pdfmake-type="columns">
        <div class="title" data-pdfmake='{"width":"*"}'>
          {{ printData?.caseDetail?.student?.firstName }}
          {{ printData?.caseDetail?.student?.lastName }}
        </div>
        <div style="width: auto"></div>
        <div
          class="title"
          style="text-align: right"
          data-pdfmake='{"width":"*"}'>
          <b>Supervisor : </b>
          {{ printData?.caseDetail?.supervisorName || '-' }}
        </div>
      </div>

      <hr data-pdfmake='{"color": "#eaecf0", "thickness": 1, "width": 552}' />

      <div data-pdfmake-type="columns">
        <div data-pdfmake='{"width":"*"}'>
          <div class="datalabel">Gender</div>
          <div class="dataValue">
            <b> {{ printData?.caseDetail?.student?.gender }}</b>
          </div>
        </div>
        <div style="width: auto">
          <div class="datalabel">Student School</div>
          <div class="dataValue">
            <b>{{ printData?.caseDetail?.student?.organizationName }}</b>
          </div>
        </div>
        <div style="text-align: left" data-pdfmake='{"width":"*"}'>
          <div class="datalabel">Date Of Birth</div>
          <div class="dataValue">
            <b>{{
              printData?.caseDetail?.student?.dateOfBirth ?? null
                | date: 'MM/dd/yyyy'
            }}</b>
          </div>
        </div>
      </div>
      <br />
      <div data-pdfmake-type="columns">
        <div data-pdfmake='{"width":"auto"}'>
          <div class="datalabel">Notes</div>
          <div class="dataValue">
            <b>{{ printData?.caseDetail?.note || 'Nothing Entered' }}</b>
          </div>
        </div>
      </div>

      <hr data-pdfmake='{"color": "#eaecf0", "thickness": 1, "width": 552}' />
      <div style="width: auto">
        <div
          class="questionContainer"
          *ngFor="let que of printData?.questionnairesData; let i = index">
          <div class="questionHeader">
            <span class="stepIndicator">{{ i + 1 }}.</span>
            <b class="questionText">
              {{ que.questionText }}
            </b>
          </div>
          <div
            *ngIf="
              que.answerTypeId !== answerType.FILEUPLOAD &&
              que.answerTypeId !== answerType.DATE &&
              que.answerTypeId !== answerType.TIME
            ">
            <b>{{ que.answerText }}</b>
          </div>
          <div *ngIf="que.answerTypeId === answerType.TIME">
            <b>{{
              !!que.answerText && que.answerText !== ''
                ? (convertToDate(que.answerText) | date: 'h:mm a')
                : '-'
            }}</b>
          </div>
          <div *ngIf="que.answerTypeId === answerType.DATE">
            <b>{{ que.answerText | date: 'MM/dd/yyyy' }}</b>
          </div>
          <div *ngIf="que.answerTypeId === answerType.FILEUPLOAD">
            <b>
              <div *ngFor="let file of getQuestionFileList(que.questionId)">
                <a [href]="file.fileUrl" target="_blank" [rel]="file.fileName">
                  {{ file.fileName }}
                </a>
              </div>
            </b>
          </div>
        </div>
      </div>
    </div>
  </body>
</html>
